// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const palafin_hero: PokeData = {
  "id": 10256,
  "name": "palafin-hero",
  "height": 18,
  "weight": 974,
  "base_experience": 160,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "supersonic",
    "mist",
    "water-gun",
    "hydro-pump",
    "focus-energy",
    "charm",
    "encore",
    "focus-punch",
    "dive",
    "astonish",
    "aqua-tail",
    "aqua-jet",
    "double-hit",
    "acrobatics",
    "flip-turn",
    "wave-crash",
    "jet-punch"
  ],
  "moves": [
    "supersonic",
    "hydro-pump",
    "aqua-tail",
    "aqua-jet",
    "acrobatics",
    "aqua-cutter",
    "bubble",
    "water-spout",
    "rain-dance",
    "life-dew",
    "liquidation",
    "whirlpool",
    "bubble-beam"
  ],
  "evolution_chain": {
    "id": 504,
    "item": null,
    "species": [
      {
        "name": "finizen",
        "order": 933,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "palafin",
        "order": 934,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 963,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 112,
    "ability_power": 180
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
